import { useMemo } from "react";
import { useGiftToken, useToken } from "./context";

export const useSelectionKey = () => {
  const token = useToken();
  const res = useMemo(() => ["selection", token] as const, [token]);
  return res;
};

export const useGiftSelectionKey = () => {
  const token = useGiftToken();
  const res = useMemo(() => ["gift", token] as const, [token]);
  return res;
};
